import { Injectable } from "@angular/core";
import { WithdrawalService } from './withdrawal.service';
import { isUndefined } from "../codeUtils";
import { ConfigService } from "../config/config.service";
@Injectable({
  providedIn: 'root'
})
export class MenuItemPreProcessor {
  constructor(
    public withdrawService: WithdrawalService,
    public configService: ConfigService
  ) {
  }

  menuItemPreProcessing(menuItem) {
    if (this.processCondition(menuItem)) {
      this.process(menuItem);
    }
    if (!!menuItem.subItems && menuItem.subItems.length > 0) {
      menuItem.subItems.forEach((item) => {
        this.menuItemPreProcessing(item);
      });
    }
  }

  processCondition(menuItem): boolean {
    // Any item speific conditions go here
    if (menuItem.displayName == "Change password") {
      return true;
    }

    if (!!menuItem.preProcessAction) {
      return true;
    }

    return false;
  }

  process(menuItem) {
    switch (menuItem.preProcessAction) {
      case "getSubItemsFromUrl":
        this.replaceSubItemsFromUrlIfExisting(menuItem);
        break;
      default:
        console.info("invalid preprocessor action");
        break;
    }

    switch (menuItem.displayName) {
      case "Change password":
        // let twoFactor = this.configService.getConfig().FEATURE_MFA_ON_EMAIL ?? 0;
        let loggedInMFA = this.configService.getConfig().FEATURE_LOGGED_IN_MFA ?? 0;
        if (loggedInMFA == 1 || loggedInMFA == "1")
          menuItem.component = "ChangePassword2FAComponent"
        break;
      default:
        break;
    }
  }

  replaceSubItemsFromUrlIfExisting(menuItem) {


    if (!menuItem.subItemsUrl) {
      return;
    }
    // const url = this.webservices_url + menuItem.subItemsUrl;
    // console.log(url);
    try {
      // this.http
      //   .get(url)
      //   .map((res) => res.json()).
      //   subscribe((data) => {
      this.withdrawService.getPayoutMethods()
        .subscribe((data) => {
          if (data.length > 0) {
            const responseItems = data;

            const formattedSubItems = responseItems
              .map((responseItem) => {
                return this.mapResponseItemToMenuItem(
                  menuItem.subItemsType,
                  responseItem
                );
              })
              .filter((a) => !!a);
            // console.log(formattedSubItems);
            delete menuItem.subItemsUrl;
            delete menuItem.subItemsType;
            delete menuItem.preProcessAction;

            // replace default only if api did actually return data
            if (formattedSubItems.length > 0) {
              menuItem.subItems = formattedSubItems;
              // Add reverse withdrawal option
              if (this.configService.getConfig().REVERSE_WITHDRAWAL_ENABLED == 1) {

                menuItem.subItems.push(
                  {
                    displayName: "Reverse Withdrawal",
                    component: "WithdrawalReverseComponent"
                  }
                );
              }
            }
          } else {
            console.log('---------empty payout methods-----');
            delete menuItem.subItemsUrl;
            delete menuItem.subItemsType;
            delete menuItem.preProcessAction;
            menuItem.subItems = [];
            // Add reverse withdrawal option
            if (this.configService.getConfig().REVERSE_WITHDRAWAL_ENABLED == 1) {
              menuItem.subItems.push(
                {
                  displayName: "Reverse Withdrawal",
                  component: "WithdrawalReverseWithdrawalPage"
                }
              );
            }
          }
        });
    } catch (e) {
      console.error("failed at getpayoutmethods api call", e);
    }
  }

  mapResponseItemToMenuItem(subItemsType: string, responseItem) {
    switch (subItemsType) {
      case "PayoutMethods":
        return this.mapWithdrawalResponseItemToMenuItem(responseItem);
      default:
        return;
    }
  }

  mapWithdrawalResponseItemToMenuItem(responseItem) {
    // console.log(responseItem);
    let name: string;
    if (!isUndefined(responseItem.PAYMENT_TYPE)) {
      name = responseItem.PAYMENT_TYPE.name;
    }

    // we should not process, if init cap is required value should be initcap in db
    // name = name.toLowerCase().split( " ").map(word => word[0].toUpperCase() + word.slice(1)).join(" ");
    switch (responseItem.PAYMENT_TYPE && responseItem.PAYMENT_TYPE.code) {
      case "PPD":
        return {
          displayName: name || "Paypal",
          component: "WithdrawalPaypalComponent",
        };
      case "SL":
        return {
          displayName: name || "Play+",
          component: "WithdrawalPrepaidComponent",
        };
      case "CAGE":
        return {
          displayName: name || "Casino Cage",
          component: "WithdrawalCageComponent"
        };
      case 'IDS':
        return {
          displayName: name || "Instant Bank Transfer - iDebit",
          component: "WithdrawalIDebitPage",
        };
      case "PWB":
        return {
          displayName: name || "Online Banking By Trustly",
          component: "WithdrawalPayWithMyBankComponent",
        };
      case "CH":
        return {
          displayName: name || "Check By Mail",
          component: "WithdrawalMailComponent",

        };
      case 'INSTA':
        return {
          displayName: name || "INSTADEBIT",
          component: "WithdrawalInstaDebitPage",
        }
      case "CH":
        return {
          displayName: name || "Check By Mail",
          component: "WithdrawalMailComponent",
        };
      case "FAF":
        return {
          displayName: name || "FastAccess",
          component: "WithdrawalFastAccessComponent",
        };
      case "GP":
        return {
          displayName: name || "ACH/E-Check",
          component: "WithdrawalVipComponent",
        }
      case "PV":
        return {
          displayName: name || "Pavilion",
          component: "WithdrawalVipPreferredComponent",
        }
      case 'GDIE':
        return {
          displayName: name || "Interac Withdrawal",
          component: "WithdrawalInteracPage",
        }
      case 'VEN':
        return {
          displayName: name || "Venmo",
          component: "WithdrawalVenmoComponent",
        }
      case 'MNI':
        return {
          displayName: name || "Interac® e-Transfer",
          component: "WithdrawalInteracPage",
        }
      case 'ACH':
        return {
          displayName: name || "Vip Ach",
          // component: "WithdrawalInteracPage",
        }
      case 'AM':
        return {
          displayName: name || "American Express",
          // component: "WithdrawalInteracPage",
        }
      case 'NETL':
        return {
          displayName: name || "Interac® e-Transfer",
          // component: "WithdrawalInteracPage",
        }
      case 'PAIBT':
        return {
          displayName: name || "Instant Bank Transfer - Paramount",
          component: "WithdrawalInstantBankTransferPage",
        }
      default:
        console.warn(
          'payment code not found or not mapped',
          {
            paymentId: responseItem.PAYOUT_METH_ID,
            code: responseItem.PAYMENT_TYPE && responseItem.PAYMENT_TYPE.code
          }
        );
        return undefined;
    }
  }
}
